import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { MEDIA } from '@constants';
import { VideoExtensionType } from '@contracts';
import LazyLoadVideo from '../LazyLoadVideo';

interface ActiveVideoProps {
  id?: string;
  mp4?: string;
  width: number;
  height: number;
  type?: VideoExtensionType;
  isActive: boolean;
  className?: string;
}

const ActiveVideo: React.FC<ActiveVideoProps> = ({ id = '', mp4, width = 1920, height = 1080, type = VideoExtensionType.MP4, isActive = false }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (isActive) {
      video.currentTime = 0;
      video.play().catch(() => {
        // Handle autoplay failure silently
      });
    } else {
      video.pause();
    }
  }, [isActive]);

  if (!mp4) {
    return null;
  }

  return (
    <Container className="video-container">
      <VideoWrapper className="video-wrapper" $width={width} $height={height}>
        <video ref={videoRef} id={id} width={width} height={height} controls={false} autoPlay={id === '0'} loop={true} muted={true} playsInline>
          <source src={mp4} type={`video/${type}`} />
        </video>
      </VideoWrapper>
    </Container>
  );
};

export default ActiveVideo;

const Container = styled.div`
  border-radius: inherit;
`;

const VideoWrapper = styled(LazyLoadVideo)<{ $width: number; $height: number }>`
  aspect-ratio: ${({ $width, $height }) => `${$width}/${$height}`};
  overflow: hidden;
  border-radius: inherit;

  video {
    object-fit: cover;
  }

  ${MEDIA.laptop} {
    video,
    & > div {
      width: 100%;
      height: 100%;
    }
  }
`;
